module.exports = __webpack_public_path__ + "img/ner_tagger_example.04034c64.svg";